import React from 'react'
import Player from "@madzadev/audio-player";


import './Reproductor.scss';

const Reproductor = () => {
    const colors = `html {
        --tagsBackground: #9440f3;
        --tagsText: #ffffff;
        --tagsBackgroundHoverActive: #2cc0a0;
        --tagsTextHoverActive: #ffffff;
        --searchBackground: #18191f;
        --searchText: #ffffff;
        --searchPlaceHolder: #575a77;
        --playerBackground: #18191f;
        --titleColor: #ffffff; 
        --timeColor: #ffffff;
        --progressSlider: #9440f3;
        --progressUsed: #ffffff;
        --progressLeft: #151616;
        --volumeSlider: #9440f3;
        --volumeUsed: #ffffff;
        --volumeLeft:  #151616;
        --playlistBackground: #181f1b;
        --playlistText: #575a77;
        --playlistBackgroundHoverActive:  #18191f;
        --playlistTextHoverActive: #ffffff;
    }`;

    const tracks = [
        {
            url: "../../audios/page9-1.mp3",
            title: "01-Exercise 1 - Page 9",
            tags: ["house"],
        },
        {
            url: "../../audios/page9-2.mp3",
            title: "02-Exercise 2 - Page 9",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page10-3.mp3",
            title: "03-Exercise 3 - Page 10",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page12-6.mp3",
            title: "04-Exercise 6 - Page 12",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page12-7.mp3",
            title: "05-Exercise 7 - Page 12",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page13-8.mp3",
            title: "06-Exercise 8 - Page 13",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page13-9.mp3",
            title: "07-Exercise 9 - Page 13",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page17-1.mp3",
            title: "8-Exercise 1 - Page 17",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page17-2.mp3",
            title: "09-Exercise 2 - Page 17",
            tags: ["house"],
        },
        {
            url: "../../audios/page18-3.mp3",
            title: "10-Exercise 3 - Page 18",
            tags: ["dnb"],
        },
        {
            url: "../../audios/page20-6.mp3",
            title: "11-Exercise 6 - Page 20",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page20-7.mp3",
            title: "12-Exercise 7 - Page 20",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page21-8.mp3",
            title: "13-Exercise 8 - Page 21",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page21-9.mp3",
            title: "14-Exercise 9 - Page 21",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page24-1.mp3",
            title: "15-Exercise 1 - Page 24",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page25-4.mp3",
            title: "16-Exercise 4 - Page 25",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page29-1.mp3",
            title: "17-Exercise 1 - Page 29",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page29-2.mp3",
            title: "18-Exercise 2 - Page 29",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page30-3.mp3",
            title: "19-Exercise 3 - Page 30",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page32-6.mp3",
            title: "20-Exercise 6 - Page 32",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page32-7.mp3",
            title: "21-Exercise 7 - Page 32",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page33-8.mp3",
            title: "22-Exercise 8 - Page 33",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page33-9.mp3",
            title: "23-Exercise 9 - Page 33",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page37-1.mp3",
            title: "24-Exercise 1 - Page 37",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page37-2.mp3",
            title: "25-Exercise 2 - Page 37",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page38-3.mp3",
            title: "26-Exercise 3 - Page 38",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page40-6.mp3",
            title: "27-Exercise 6 - Page 40",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page42-9.mp3",
            title: "28-Exercise 9 - Page 42",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page44-1.mp3",
            title: "29-Exercise 1 - Page 44",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page44-2.mp3",
            title: "30-Exercise 2 - Page 44",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page45-4.mp3",
            title: "31-Exercise 4 - Page 45",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page46-5.mp3",
            title: "32-Exercise 5 - Page 46",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page49-1.mp3",
            title: "33-Exercise 1 - Page 49",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page49-2.mp3",
            title: "34-Exercise 2 - Page 49",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page50-3.mp3",
            title: "35-Exercise 3 - Page 50",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page52-7.mp3",
            title: "36-Exercise 7 - Page 52",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page54-9.mp3",
            title: "37-Exercise 9 - Page 54",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page57-1.mp3",
            title: "38-Exercise 1 - Page 57",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page57-2.mp3",
            title: "39-Exercise 2 - Page 57",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page58-3.mp3",
            title: "40-Exercise 3 - Page 58",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page60-6.mp3",
            title: "41-Exercise 6 - Page 60",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page60-7.mp3",
            title: "42-Exercise 7 - Page 60",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page61-8.mp3",
            title: "43-Exercise 8 - Page 61",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page62-11.mp3",
            title: "44-Exercise 11 - Page 62",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page64-1.mp3",
            title: "45-Exercise 1 - Page 64",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page66-6.mp3",
            title: "46-Exercise 6 - Page 66",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page69-1.mp3",
            title: "47-Exercise 1 - Page 69",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page69-2.mp3",
            title: "48-Exercise 2 - Page 69",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page70-3.mp3",
            title: "49-Exercise 3 - Page 70",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page72-6.mp3",
            title: "50-Exercise 6 - Page 72",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page73-8.mp3",
            title: "51-Exercise 8 - Page 73",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page74-10.mp3",
            title: "52-Exercise 10 - Page 74",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page74-11.mp3",
            title: "53-Exercise 11 - Page 74",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page77-1.mp3",
            title: "53-Exercise 1 - Page 77",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page77-2.mp3",
            title: "54-Exercise 2 - Page 77",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page78-3.mp3",
            title: "55-Exercise 3 - Page 78",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page80-6.mp3",
            title: "56-Exercise 6 - Page 80",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page81-8.mp3",
            title: "57-Exercise 8 - Page 81",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page82-10.mp3",
            title: "58-Exercise 10 - Page 82",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page85-2.mp3",
            title: "59-Exercise 2 - Page 85",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page89-2.mp3",
            title: "60-Exercise 2 - Page 89",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page90-3.mp3",
            title: "61-Exercise 3 - Page 90",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page93-8.mp3",
            title: "62-Exercise 8 - Page 93",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page94-10.mp3",
            title: "63-Exercise 10 - Page 94",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page97-1.mp3",
            title: "64-Exercise 1 - Page 97",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page97-2.mp3",
            title: "65-Exercise 2 - Page 97",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page98-3.mp3",
            title: "66-Exercise 3 - Page 98",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page100-6.mp3",
            title: "67-Exercise 6 - Page 100",
            tags: ["dubstep"],
        },
        {    
            url: "../../audios/page100-7.mp3",
            title: "68-Exercise 7 - Page 100",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page101-8.mp3",
            title: "69-Exercise 8 - Page 101",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page102-3.mp3",
            title: "70-Exercise 3 - Page 102",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page102-4.mp3",
            title: "71-Exercise 4 - Page 102",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page110-1.mp3",
            title: "72-Exercise 1 - Page 110",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page113-2.mp3",
            title: "73-Exercise 2 - Page 113",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page116-2.mp3",
            title: "74-Exercise 3 - Page 116",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/page118-2.mp3",
            title: "75-Exercise 2 - Page 118",
            tags: ["dubstep"],   
        },
        {
            url: "../../audios/page121-3.mp3",
            title: "76-Exercise 3 - Page 121",
            tags: ["dubstep"], 
        },
        {
            url: "../../audios/page124-2.mp3",
            title: "77-Exercise 2 - Page 124",
            tags: ["dubstep"], 
        },
        {
            url: "../../audios/page126-1.mp3",
            title: "78-Exercise 2 - Page 126",
            tags: ["dubstep"], 
        },
        {
            url: "../../audios/page128-1.mp3",
            title: "79-Exercise 2 - Page 128",
            tags: ["dubstep"], 
        },
        {
            url: "../../audios/page129-3.mp3",
            title: "80-Exercise 3 - Page 129",
            tags: ["dubstep"], 
        }
    ];

    return (
        <Player 
            trackList={tracks}
            includeTags={false}
            ncludeSearch={true}
            showPlaylist={true}
            autoPlayNextTrack={true}
            customColorScheme={colors}
        />
    )
}

export default Reproductor